import { CateringEventCategoryModelSchema } from 'entities/catering-event-category';
import { z } from 'zod';

export const PortfolioEventCardModelSchema = z.object({
    uid: z.string(),
    description: z.any().optional().nullable(),
    name: z.string(),
    images: z.array(z.object({
        url: z.string(),
    })).optional().nullable(),
    category: CateringEventCategoryModelSchema.optional().nullable(),
});

export type PortfolioEventCardModel = z.infer<typeof PortfolioEventCardModelSchema>;
